<script setup lang="ts">
// Ikonerne i bundmenuen. Streg-ikoner frem for emoji: emoji tegnes af styresystemet, saa de
// kan hverken arve menuens farve (den aktive fane er aqua) eller se ens ud paa iOS, Android
// og desktop. Samme 24-felt og samme stregtykkelse som brandmaerket i headeren.
defineProps<{ name: 'waves' | 'star' | 'wrench' | 'user' }>()
</script>

<template>
  <svg
    class="tab-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <!-- Steder: de samme tre boelger som brandmaerket, saa forsiden og logoet siger det samme. -->
    <g v-if="name === 'waves'" transform="translate(1.25 0)">
      <path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 1.3 0 1.9-.5 2.5-1" />
      <path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 1.3 0 1.9-.5 2.5-1" />
      <path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 1.3 0 1.9-.5 2.5-1" />
    </g>
    <path
      v-else-if="name === 'star'"
      d="M12 2.6l3 6.1 6.7 1-4.85 4.72 1.15 6.68L12 17.95l-6 3.15 1.15-6.68L2.3 9.7l6.7-1z"
    />
    <path
      v-else-if="name === 'wrench'"
      d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
    />
    <template v-else>
      <circle cx="12" cy="7.6" r="3.6" />
      <path d="M19 20.4v-1.4a4.2 4.2 0 0 0-4.2-4.2H9.2A4.2 4.2 0 0 0 5 19v1.4" />
    </template>
  </svg>
</template>
